module.exports = __webpack_public_path__ + "img/celts-DE.bf777084.png";